
import DataTable from 'datatables.net-react';
import React, { useEffect, useState } from 'react';
import Card from 'react-bootstrap/Card';
import { BlockedscriptServices } from '../../services/BlockedScriptServices';
import * as BullCache from "../../util/BullCache";
import '../custom.css';

function Blockedscript() {

  const [master, setMaster] = useState([]);
  const [broker, setBroker] = useState([]);
  const [Client, setclient] = useState([]);
  const [blockedScripts, setBlockedscripts] = useState([]);

  var user = BullCache.getFromCache("user");
  useEffect(() => {
    BlockedscriptServices.getMaster({ 'adminId': user.adminId }).then(res => {

      if (res.code === 1) {

        if (res.data.masterList.length > 0) {

          setMaster(res.data.masterList);
        }
        if (res.data.brokerList.length > 0) {

          setBroker(res.data.brokerList);
        }
      }      
    });

    BlockedscriptServices.getUsers({ 'adminId': user.adminId }).then(res => {

      if (res.code === 1) {

        if (res.data.userList.length > 0) {
          setclient(res.data.userList);
        }
      }

      

    });

    BlockedscriptServices.getScript({ 'adminId': user.adminId }).then(resp => {
     
      if (resp.code === 1) {
        if (resp.data.blockedScripts.length > 0) {
          setBlockedscripts(resp.data.blockedScripts);
        }
      }
    });


  }, []);

  const columns = [
    { title: 'SCRIPTS', data: 'script', className: ' font-bold ' },
    { title: 'BLOCKED BY', data: 'blockedBy', className: ' font-bold font-color '},
  ];

  return (
    <div className='container-fluid'>
      
      <Card className='mt-2'>

        <Card.Body>

        <DataTable   id="table" className="mt-1 table table-striped  bg-secondary-row fss-05"
            columns={columns} data={blockedScripts} >
        </DataTable>
        </Card.Body>
      </Card>

    </div>


  );
}

export default Blockedscript;